var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM56(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5433_44371",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5433_44371",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACGElEQVRo3u2aTUsCURSGZ2Ercaf7sjIiyIVl/QhLaheiWP0CXUZjgUFto38RqfUL2lVUGm4KJdr0RW0jwQqm98RIg01+NXdmjnnh2aiL97lz1XvPuZLUG99DURQnCIIFkACySkJ9jd5z2ibww3q/VL058iNUGpyBd6X5eFc/mz55vvSP7cYtCJ7yOkAM5F8Ot5VOx87VvjKSjedBFDiEB7+Xhyh8GJSBQhggUKMEwsPZqLBZd4NMLbgAgRoZ4DY6fBDc1ocXJEDcgqBR4WdARS+8QAHiFYSMCP/2W3jBAkS1YwmEm2o08yYJEJW2lxOCecBds/AmCRB3wNNS+Ed5kARyrYQ3UYDI+XLxlmZ/vtXwJgsQc83C94FrGwtcg75GAovthLdAgFjU3yasfa39IgOBoi+7pDv7E+2Gt0iACOgJbDES2NQTuGAkUKgP7wIfjAQ+gEsrMN1JeAsFiGmtQIShQEQrkGQokNQKyAwF5K4SYL+E2H+J2f+M8v4jUyUKbLcSqsAm981cgJHAhE7dk8+BZjQT78IjZVcc6lWJORsLzDcvbKW8JJG1Y2EL/IPSYl1P4NUmxd2pTivUIVC1uLw+89ceQajRkxAoUPlzeI3EJNsWU12Tb8+kJp9HEjGeVr/arLOgJECgTG3Wkb0l0xrdUXBuUKM7Zkqj+8cTWRmQqjfH4+pVg9M2rxpsHNNVg4Pl3mUP1uMTtKCBgwkH1bgAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM56);
export default __webpack_public_path__ + "static/media/m56.de372a26a40227eaef8f68fafabe3763.svg";
export { ForwardRef as ReactComponent };